// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { AssetInfoFragmentDoc } from '../assets/AssetPreview.generated';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CheckoutSettingsTab_CommunityQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type CheckoutSettingsTab_CommunityQuery = { __typename?: 'Query', community: { __typename?: 'Community', id: string, pricingTeaser?: string | null | undefined, showInCheckout: boolean, lotMap?: string | null | undefined, packageComparison?: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } | null | undefined } };

export type SaveCommunitySettingsMutationVariables = Types.Exact<{
  input: Types.SaveCommunityInput;
}>;


export type SaveCommunitySettingsMutation = { __typename?: 'Mutation', saveCommunity: { __typename?: 'SaveCommunityResult', community: { __typename?: 'Community', id: string, pricingTeaser?: string | null | undefined, showInCheckout: boolean, lotMap?: string | null | undefined, packageComparison?: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } | null | undefined } } };

export type CheckoutSettingsTab_CommunityFragment = { __typename?: 'Community', id: string, pricingTeaser?: string | null | undefined, showInCheckout: boolean, lotMap?: string | null | undefined, packageComparison?: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } | null | undefined };

export type CheckoutSettingsTab_StructureQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type CheckoutSettingsTab_StructureQuery = { __typename?: 'Query', structure: { __typename?: 'Structure', id: string, showInCheckout: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, includedPriceInCents?: number | null | undefined, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, priceInCents: number, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number } } }>, includedOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }>, readyPlan?:
        | { __typename?: 'ReadyPlan', id: string }
        | { __typename?: 'PlanPackage', id: string }
        | { __typename?: 'DesignPackage', id: string }
        | { __typename?: 'ProductOffering', id: string }
       | null | undefined } | null | undefined } };

export type CheckoutSettingsTab_ProductOfferingOptionsQueryVariables = Types.Exact<{
  productOfferingId: Types.Scalars['ID']['input'];
}>;


export type CheckoutSettingsTab_ProductOfferingOptionsQuery = { __typename?: 'Query', productOffering: { __typename?: 'ProductOffering', id: string, optionGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, active: boolean, order: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, active: boolean, showInCheckout: boolean }> }> } };

export type SaveStructureSettingsMutationVariables = Types.Exact<{
  input: Types.SaveStructureInput;
}>;


export type SaveStructureSettingsMutation = { __typename?: 'Mutation', saveStructure: { __typename?: 'SaveStructureResult', structure: { __typename?: 'Structure', id: string, showInCheckout: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, includedPriceInCents?: number | null | undefined, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, priceInCents: number, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number } } }>, includedOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }>, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string }
          | { __typename?: 'PlanPackage', id: string }
          | { __typename?: 'DesignPackage', id: string }
          | { __typename?: 'ProductOffering', id: string }
         | null | undefined } | null | undefined } } };

export type CheckoutSettingsTab_StructureFragment = { __typename?: 'Structure', id: string, showInCheckout: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, includedPriceInCents?: number | null | undefined, options: Array<{ __typename?: 'ProjectReadyPlanConfigOption', id: string, priceInCents: number, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number } } }>, includedOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }>, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string }
      | { __typename?: 'PlanPackage', id: string }
      | { __typename?: 'DesignPackage', id: string }
      | { __typename?: 'ProductOffering', id: string }
     | null | undefined } | null | undefined };

export type CheckoutSettingsTab_LotQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type CheckoutSettingsTab_LotQuery = { __typename?: 'Query', lot: { __typename?: 'Lot', id: string, buildablePlans: Array<{ __typename?: 'ProductOffering', id: string, name: string }>, parent: { __typename?: 'Subdivision', id: string, parent: { __typename?: 'Community', id: string, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, name: string }> } } } };

export type SaveLotSettingsMutationVariables = Types.Exact<{
  input: Types.SaveLotInput;
}>;


export type SaveLotSettingsMutation = { __typename?: 'Mutation', saveLot: { __typename?: 'SaveLotResult', lot: { __typename?: 'Lot', id: string, buildablePlans: Array<{ __typename?: 'ProductOffering', id: string, name: string }>, parent: { __typename?: 'Subdivision', id: string, parent: { __typename?: 'Community', id: string, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, name: string }> } } } } };

export type CheckoutSettingsTab_LotFragment = { __typename?: 'Lot', id: string, buildablePlans: Array<{ __typename?: 'ProductOffering', id: string, name: string }>, parent: { __typename?: 'Subdivision', id: string, parent: { __typename?: 'Community', id: string, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, name: string }> } } };

export const CheckoutSettingsTab_CommunityFragmentDoc = gql`
    fragment CheckoutSettingsTab_Community on Community {
  id
  pricingTeaser
  showInCheckout
  packageComparison {
    ...AssetInfo
  }
  lotMap
}
    ${AssetInfoFragmentDoc}`;
export const CheckoutSettingsTab_StructureFragmentDoc = gql`
    fragment CheckoutSettingsTab_Structure on Structure {
  id
  showInCheckout
  readyPlanConfig {
    id
    includedPriceInCents
    options {
      id
      priceInCents
      readyPlanOption {
        id
        displayName
        optionGroup {
          id
          order
        }
      }
    }
    includedOptions {
      id
    }
    readyPlan {
      id
    }
  }
}
    `;
export const CheckoutSettingsTab_LotFragmentDoc = gql`
    fragment CheckoutSettingsTab_Lot on Lot {
  id
  buildablePlans {
    ...Named
  }
  parent {
    id
    parent {
      id
      productOfferings {
        ...Named
      }
    }
  }
}
    ${NamedFragmentDoc}`;
export const CheckoutSettingsTab_CommunityDocument = gql`
    query CheckoutSettingsTab_Community($projectId: ID!) {
  community(id: $projectId) {
    ...CheckoutSettingsTab_Community
  }
}
    ${CheckoutSettingsTab_CommunityFragmentDoc}`;

/**
 * __useCheckoutSettingsTab_CommunityQuery__
 *
 * To run a query within a React component, call `useCheckoutSettingsTab_CommunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutSettingsTab_CommunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutSettingsTab_CommunityQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCheckoutSettingsTab_CommunityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CheckoutSettingsTab_CommunityQuery, CheckoutSettingsTab_CommunityQueryVariables> & ({ variables: CheckoutSettingsTab_CommunityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckoutSettingsTab_CommunityQuery, CheckoutSettingsTab_CommunityQueryVariables>(CheckoutSettingsTab_CommunityDocument, options);
      }
export function useCheckoutSettingsTab_CommunityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckoutSettingsTab_CommunityQuery, CheckoutSettingsTab_CommunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckoutSettingsTab_CommunityQuery, CheckoutSettingsTab_CommunityQueryVariables>(CheckoutSettingsTab_CommunityDocument, options);
        }
// @ts-ignore
export function useCheckoutSettingsTab_CommunitySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CheckoutSettingsTab_CommunityQuery, CheckoutSettingsTab_CommunityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CheckoutSettingsTab_CommunityQuery, CheckoutSettingsTab_CommunityQueryVariables>;
export function useCheckoutSettingsTab_CommunitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckoutSettingsTab_CommunityQuery, CheckoutSettingsTab_CommunityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CheckoutSettingsTab_CommunityQuery | undefined, CheckoutSettingsTab_CommunityQueryVariables>;
export function useCheckoutSettingsTab_CommunitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckoutSettingsTab_CommunityQuery, CheckoutSettingsTab_CommunityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CheckoutSettingsTab_CommunityQuery, CheckoutSettingsTab_CommunityQueryVariables>(CheckoutSettingsTab_CommunityDocument, options);
        }
export type CheckoutSettingsTab_CommunityQueryHookResult = ReturnType<typeof useCheckoutSettingsTab_CommunityQuery>;
export type CheckoutSettingsTab_CommunityLazyQueryHookResult = ReturnType<typeof useCheckoutSettingsTab_CommunityLazyQuery>;
export type CheckoutSettingsTab_CommunitySuspenseQueryHookResult = ReturnType<typeof useCheckoutSettingsTab_CommunitySuspenseQuery>;
export type CheckoutSettingsTab_CommunityQueryResult = ApolloReactCommon.QueryResult<CheckoutSettingsTab_CommunityQuery, CheckoutSettingsTab_CommunityQueryVariables>;
export const SaveCommunitySettingsDocument = gql`
    mutation SaveCommunitySettings($input: SaveCommunityInput!) {
  saveCommunity(input: $input) {
    community {
      ...CheckoutSettingsTab_Community
    }
  }
}
    ${CheckoutSettingsTab_CommunityFragmentDoc}`;

/**
 * __useSaveCommunitySettingsMutation__
 *
 * To run a mutation, you first call `useSaveCommunitySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCommunitySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCommunitySettingsMutation, { data, loading, error }] = useSaveCommunitySettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCommunitySettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveCommunitySettingsMutation, SaveCommunitySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveCommunitySettingsMutation, SaveCommunitySettingsMutationVariables>(SaveCommunitySettingsDocument, options);
      }
export type SaveCommunitySettingsMutationHookResult = ReturnType<typeof useSaveCommunitySettingsMutation>;
export type SaveCommunitySettingsMutationResult = ApolloReactCommon.MutationResult<SaveCommunitySettingsMutation>;
export const CheckoutSettingsTab_StructureDocument = gql`
    query CheckoutSettingsTab_Structure($projectId: ID!) {
  structure(id: $projectId) {
    ...CheckoutSettingsTab_Structure
  }
}
    ${CheckoutSettingsTab_StructureFragmentDoc}`;

/**
 * __useCheckoutSettingsTab_StructureQuery__
 *
 * To run a query within a React component, call `useCheckoutSettingsTab_StructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutSettingsTab_StructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutSettingsTab_StructureQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCheckoutSettingsTab_StructureQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CheckoutSettingsTab_StructureQuery, CheckoutSettingsTab_StructureQueryVariables> & ({ variables: CheckoutSettingsTab_StructureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckoutSettingsTab_StructureQuery, CheckoutSettingsTab_StructureQueryVariables>(CheckoutSettingsTab_StructureDocument, options);
      }
export function useCheckoutSettingsTab_StructureLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckoutSettingsTab_StructureQuery, CheckoutSettingsTab_StructureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckoutSettingsTab_StructureQuery, CheckoutSettingsTab_StructureQueryVariables>(CheckoutSettingsTab_StructureDocument, options);
        }
// @ts-ignore
export function useCheckoutSettingsTab_StructureSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CheckoutSettingsTab_StructureQuery, CheckoutSettingsTab_StructureQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CheckoutSettingsTab_StructureQuery, CheckoutSettingsTab_StructureQueryVariables>;
export function useCheckoutSettingsTab_StructureSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckoutSettingsTab_StructureQuery, CheckoutSettingsTab_StructureQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CheckoutSettingsTab_StructureQuery | undefined, CheckoutSettingsTab_StructureQueryVariables>;
export function useCheckoutSettingsTab_StructureSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckoutSettingsTab_StructureQuery, CheckoutSettingsTab_StructureQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CheckoutSettingsTab_StructureQuery, CheckoutSettingsTab_StructureQueryVariables>(CheckoutSettingsTab_StructureDocument, options);
        }
export type CheckoutSettingsTab_StructureQueryHookResult = ReturnType<typeof useCheckoutSettingsTab_StructureQuery>;
export type CheckoutSettingsTab_StructureLazyQueryHookResult = ReturnType<typeof useCheckoutSettingsTab_StructureLazyQuery>;
export type CheckoutSettingsTab_StructureSuspenseQueryHookResult = ReturnType<typeof useCheckoutSettingsTab_StructureSuspenseQuery>;
export type CheckoutSettingsTab_StructureQueryResult = ApolloReactCommon.QueryResult<CheckoutSettingsTab_StructureQuery, CheckoutSettingsTab_StructureQueryVariables>;
export const CheckoutSettingsTab_ProductOfferingOptionsDocument = gql`
    query CheckoutSettingsTab_ProductOfferingOptions($productOfferingId: ID!) {
  productOffering(id: $productOfferingId) {
    id
    optionGroups {
      id
      name
      active
      order
      options {
        id
        name
        active
        showInCheckout
      }
    }
  }
}
    `;

/**
 * __useCheckoutSettingsTab_ProductOfferingOptionsQuery__
 *
 * To run a query within a React component, call `useCheckoutSettingsTab_ProductOfferingOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutSettingsTab_ProductOfferingOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutSettingsTab_ProductOfferingOptionsQuery({
 *   variables: {
 *      productOfferingId: // value for 'productOfferingId'
 *   },
 * });
 */
export function useCheckoutSettingsTab_ProductOfferingOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CheckoutSettingsTab_ProductOfferingOptionsQuery, CheckoutSettingsTab_ProductOfferingOptionsQueryVariables> & ({ variables: CheckoutSettingsTab_ProductOfferingOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckoutSettingsTab_ProductOfferingOptionsQuery, CheckoutSettingsTab_ProductOfferingOptionsQueryVariables>(CheckoutSettingsTab_ProductOfferingOptionsDocument, options);
      }
export function useCheckoutSettingsTab_ProductOfferingOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckoutSettingsTab_ProductOfferingOptionsQuery, CheckoutSettingsTab_ProductOfferingOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckoutSettingsTab_ProductOfferingOptionsQuery, CheckoutSettingsTab_ProductOfferingOptionsQueryVariables>(CheckoutSettingsTab_ProductOfferingOptionsDocument, options);
        }
// @ts-ignore
export function useCheckoutSettingsTab_ProductOfferingOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CheckoutSettingsTab_ProductOfferingOptionsQuery, CheckoutSettingsTab_ProductOfferingOptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CheckoutSettingsTab_ProductOfferingOptionsQuery, CheckoutSettingsTab_ProductOfferingOptionsQueryVariables>;
export function useCheckoutSettingsTab_ProductOfferingOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckoutSettingsTab_ProductOfferingOptionsQuery, CheckoutSettingsTab_ProductOfferingOptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CheckoutSettingsTab_ProductOfferingOptionsQuery | undefined, CheckoutSettingsTab_ProductOfferingOptionsQueryVariables>;
export function useCheckoutSettingsTab_ProductOfferingOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckoutSettingsTab_ProductOfferingOptionsQuery, CheckoutSettingsTab_ProductOfferingOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CheckoutSettingsTab_ProductOfferingOptionsQuery, CheckoutSettingsTab_ProductOfferingOptionsQueryVariables>(CheckoutSettingsTab_ProductOfferingOptionsDocument, options);
        }
export type CheckoutSettingsTab_ProductOfferingOptionsQueryHookResult = ReturnType<typeof useCheckoutSettingsTab_ProductOfferingOptionsQuery>;
export type CheckoutSettingsTab_ProductOfferingOptionsLazyQueryHookResult = ReturnType<typeof useCheckoutSettingsTab_ProductOfferingOptionsLazyQuery>;
export type CheckoutSettingsTab_ProductOfferingOptionsSuspenseQueryHookResult = ReturnType<typeof useCheckoutSettingsTab_ProductOfferingOptionsSuspenseQuery>;
export type CheckoutSettingsTab_ProductOfferingOptionsQueryResult = ApolloReactCommon.QueryResult<CheckoutSettingsTab_ProductOfferingOptionsQuery, CheckoutSettingsTab_ProductOfferingOptionsQueryVariables>;
export const SaveStructureSettingsDocument = gql`
    mutation SaveStructureSettings($input: SaveStructureInput!) {
  saveStructure(input: $input) {
    structure {
      ...CheckoutSettingsTab_Structure
    }
  }
}
    ${CheckoutSettingsTab_StructureFragmentDoc}`;

/**
 * __useSaveStructureSettingsMutation__
 *
 * To run a mutation, you first call `useSaveStructureSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveStructureSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveStructureSettingsMutation, { data, loading, error }] = useSaveStructureSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveStructureSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveStructureSettingsMutation, SaveStructureSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveStructureSettingsMutation, SaveStructureSettingsMutationVariables>(SaveStructureSettingsDocument, options);
      }
export type SaveStructureSettingsMutationHookResult = ReturnType<typeof useSaveStructureSettingsMutation>;
export type SaveStructureSettingsMutationResult = ApolloReactCommon.MutationResult<SaveStructureSettingsMutation>;
export const CheckoutSettingsTab_LotDocument = gql`
    query CheckoutSettingsTab_Lot($projectId: ID!) {
  lot(id: $projectId) {
    ...CheckoutSettingsTab_Lot
  }
}
    ${CheckoutSettingsTab_LotFragmentDoc}`;

/**
 * __useCheckoutSettingsTab_LotQuery__
 *
 * To run a query within a React component, call `useCheckoutSettingsTab_LotQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutSettingsTab_LotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutSettingsTab_LotQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCheckoutSettingsTab_LotQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CheckoutSettingsTab_LotQuery, CheckoutSettingsTab_LotQueryVariables> & ({ variables: CheckoutSettingsTab_LotQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckoutSettingsTab_LotQuery, CheckoutSettingsTab_LotQueryVariables>(CheckoutSettingsTab_LotDocument, options);
      }
export function useCheckoutSettingsTab_LotLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckoutSettingsTab_LotQuery, CheckoutSettingsTab_LotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckoutSettingsTab_LotQuery, CheckoutSettingsTab_LotQueryVariables>(CheckoutSettingsTab_LotDocument, options);
        }
// @ts-ignore
export function useCheckoutSettingsTab_LotSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CheckoutSettingsTab_LotQuery, CheckoutSettingsTab_LotQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CheckoutSettingsTab_LotQuery, CheckoutSettingsTab_LotQueryVariables>;
export function useCheckoutSettingsTab_LotSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckoutSettingsTab_LotQuery, CheckoutSettingsTab_LotQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CheckoutSettingsTab_LotQuery | undefined, CheckoutSettingsTab_LotQueryVariables>;
export function useCheckoutSettingsTab_LotSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckoutSettingsTab_LotQuery, CheckoutSettingsTab_LotQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CheckoutSettingsTab_LotQuery, CheckoutSettingsTab_LotQueryVariables>(CheckoutSettingsTab_LotDocument, options);
        }
export type CheckoutSettingsTab_LotQueryHookResult = ReturnType<typeof useCheckoutSettingsTab_LotQuery>;
export type CheckoutSettingsTab_LotLazyQueryHookResult = ReturnType<typeof useCheckoutSettingsTab_LotLazyQuery>;
export type CheckoutSettingsTab_LotSuspenseQueryHookResult = ReturnType<typeof useCheckoutSettingsTab_LotSuspenseQuery>;
export type CheckoutSettingsTab_LotQueryResult = ApolloReactCommon.QueryResult<CheckoutSettingsTab_LotQuery, CheckoutSettingsTab_LotQueryVariables>;
export const SaveLotSettingsDocument = gql`
    mutation SaveLotSettings($input: SaveLotInput!) {
  saveLot(input: $input) {
    lot {
      ...CheckoutSettingsTab_Lot
    }
  }
}
    ${CheckoutSettingsTab_LotFragmentDoc}`;

/**
 * __useSaveLotSettingsMutation__
 *
 * To run a mutation, you first call `useSaveLotSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLotSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLotSettingsMutation, { data, loading, error }] = useSaveLotSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveLotSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveLotSettingsMutation, SaveLotSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveLotSettingsMutation, SaveLotSettingsMutationVariables>(SaveLotSettingsDocument, options);
      }
export type SaveLotSettingsMutationHookResult = ReturnType<typeof useSaveLotSettingsMutation>;
export type SaveLotSettingsMutationResult = ApolloReactCommon.MutationResult<SaveLotSettingsMutation>;